export default values => {
  const errors = {}
  if (!values.friendlyName) {
    errors.friendlyName = "Cannot be blank"
  }
  return errors
}



// WEBPACK FOOTER //
// ./src/Sensors/validate.js